import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useAdminUpdateClientMutation } from 'api';
import { useProtectedClient } from 'hooks';
import { useAdminUpdateClient } from 'features/admin/updaters';
import { Capability } from 'components';
import { PRE_SELF_SERVE_USER_CREATED_AT_TIME } from 'app-constants';
import * as paths from 'paths';

import SetupButton from './SetupButton';

const SetupWorkspaceButton: FC = () => {
  const client = useProtectedClient();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const mutationOptions = useAdminUpdateClient();
  const { mutate: updateClient } = useAdminUpdateClientMutation(mutationOptions);

  function handleClose() {
    updateClient({ data: { id: client.id, setup_completed: true } });
  }

  if (client.setup_completed || client.created_at < PRE_SELF_SERVE_USER_CREATED_AT_TIME) {
    return null;
  }

  return (
    <Capability name="Access.Admin">
      <SetupButton
        label={t('setup:setupWorkspace')}
        onClick={() => navigate(paths.setupWorkspace)}
        onClose={handleClose}
      />
    </Capability>
  );
};

export default SetupWorkspaceButton;
